module.exports = __webpack_public_path__ + "media/images/admin/4pt-logo-dcd9dbbc9883ffa6b555188b117603ef.png";